<template>
    <div>
        <b-table-simple small borderless responsive fixed class="table-head-light no-padding">
            <b-thead>
                <b-tr>
                    <b-th key="show_details" class="text-center align-middle col-icon"></b-th>
                    <b-th key="position" class="text-center align-middle col-icon"></b-th>
                    <b-th key="name" class="required">
                        <div>
                            Name
                            <b-link :id="getFieldId(stepIndex,'title','name-help')">
                                <b-icon icon="question-circle" variant="primary"></b-icon>
                            </b-link>
                            <b-popover :target="getFieldId(stepIndex,'title','name-help')" triggers="hover"
                                       placement="top"
                                       v-if="step.type === 'SUMMARY'">
                                <i>[submission or submitter]</i><b class="text-primary">.</b><i>[Field name]</i>
                            </b-popover>
                            <b-popover :target="getFieldId(stepIndex,'title','name-help')" triggers="hover"
                                       placement="top"
                                       v-if="step.type !== 'SUMMARY'">
                                The field name used in classic.
                            </b-popover>
                        </div>
                    </b-th>
                    <b-th key="label" class="required">
                        <div>Label</div>
                    </b-th>
                    <b-th key="type" class="required">
                        <div> Type</div>
                    </b-th>
                    <b-th key="btnStyled" class="text-center align-middle col-ckc">
                        <div>
                            Styled
                            <b-link :id="getFieldId(stepIndex,'title','btnStyledHelp')">
                                <b-icon icon="question-circle" variant="primary"></b-icon>
                            </b-link>
                            <b-popover :target="getFieldId(stepIndex,'title','btnStyledHelp')" triggers="hover"
                                       placement="top">
                                If selected it renders checkbox or radio inputs to appear as buttons.
                            </b-popover>
                        </div>
                    </b-th>
                    <b-th key="size" style="width: 90px">
                        <div>Size</div>
                    </b-th>
                    <b-th key="linkedClass" class="">
                        <div>Linked Class</div>
                    </b-th>
                    <b-th key="required" class="text-center align-middle col-ckc">
                        <div>Required</div>
                    </b-th>
                    <b-th key="hidden" class="text-center align-middle col-ckc">
                        <div>Hidden</div>
                    </b-th>
                    <b-th key="edit-field" class="text-center align-middle col-icon">
                        <b-link @click="addField()" class="h4 text-primary">
                            <b-icon icon="plus-circle"></b-icon>
                        </b-link>
                    </b-th>
                    <b-th key="edit-more" class="text-center align-middle col-icon">
                    </b-th>
                </b-tr>
            </b-thead>
            <draggable :list="fields" tag="tbody" @change="changePosition" ghost-class="ghost" handle=".handle-field">
                <b-tr v-for="field in fields" :key="field.position" class="grab">
                    <b-td colspan="12">
                        <b-table-simple small borderless responsive fixed class="m-0" style="overflow: unset;">
                            <b-tr>
                                <b-td class="text-center align-middle col-icon handle-field">
                                    <b-link v-b-toggle="getFieldId(stepIndex, field.position,'collapse-details')"
                                            class="text-secondary" size="sm">
                                        <b-icon class="when-opened" icon="chevron-down"></b-icon>
                                        <b-icon class="when-closed" icon="chevron-right"></b-icon>
                                    </b-link>
                                </b-td>
                                <b-td class="text-center align-middle col-icon handle-field">
                                    <b-badge pill variant="primary">{{ field.position }}</b-badge>
                                </b-td>
                                <b-td>
                                    <b-form-input v-if="!currentPortal.leadSpace"
                                                  :id="getFieldId(stepIndex, field.position,'name')"
                                                  :name="getFieldId(stepIndex, field.position,'name')"
                                                  :value="field.name" @change="v => field.name = v"/>
                                    <vue-typeahead-bootstrap v-if="currentPortal.leadSpace"
                                                             :id="getFieldId(stepIndex, field.position,'name')"
                                                             :name="getFieldId(stepIndex, field.position,'name')"
                                                             :value="field.name"
                                                             :data="step.type === 'SUBMITTER' || step.type === 'CONTACT' ? lsContactFields : lsFields"
                                                             @input="v => field.name = v"
                                                             @hit="selectField(field, $event)"
                                                             :serializer="item => item.name" :max-matches="30"
                                                             style="flex: 1 1 auto;">
                                        <template v-slot:suggestion="{ data, htmlText }">
                                            <span>{{ data.label }}</span><br>
                                            <small class="text-muted" v-html="htmlText"></small>
                                        </template>
                                    </vue-typeahead-bootstrap>
                                    <b-form-text :id="getFieldId(field.position, 'er-feedback')" text-variant="danger"
                                                 v-if="field.name === 'tags.myfield'">
                                        <span>The field name tags.<b>myfield</b> need to be updated.</span>
                                    </b-form-text>
                                </b-td>
                                <b-td>
                                    <b-form-input :id="getFieldId(stepIndex, field.position,'label')"
                                                  :name="getFieldId(stepIndex, field.position,'label')"
                                                  :value="field.label" @change="v => field.label = v"/>
                                </b-td>
                                <b-td>
                                    <b-form-select :id="getFieldId(stepIndex, field.position,'type')"
                                                   :name="getFieldId(stepIndex, field.position,'type')"
                                                   v-model="field.type"
                                                   :options="step.type === 'SUMMARY' ? $enums['fieldSummaryTypes'] : $enums['fieldType']"
                                                   required></b-form-select>
                                </b-td>
                                <b-td class="text-center align-middle col-ckc">
                                    <b-form-checkbox :id="getFieldId(stepIndex, field.position,'btnStyled')"
                                                     :name="getFieldId(stepIndex, field.position,'btnStyled')"
                                                     v-model="field.btnStyled"
                                                     v-if="$enums['fieldTypesBtn'].includes(field.type)"/>
                                </b-td>
                                <!-- Field size -->
                                <b-td style="width: 90px">
                                    <b-form-select :id="getFieldId(stepIndex, field.position,'size')"
                                                   :name="getFieldId(stepIndex, field.position,'size')"
                                                   v-model="field.size" :options="fieldSizes" required/>
                                </b-td>
                                <!-- Field linkedCLass -->
                                <b-td>
                                    <!-- Linked class -->
                                    <b-input-group v-if="$enums['fieldTypesLC'].includes(field.type) &&
                                        !(currentPortal.leadSpace && field.name && field.name.includes('tags.'))">
                                        <b-form-input :id="getFieldId(stepIndex, field.position,'linkedClass')"
                                                      :name="getFieldId(stepIndex, field.position,'linkedClass')"
                                                      :value="field.linkedClass" @change="v => field.linkedClass = v"/>
                                        <b-input-group-append is-text
                                                              v-if="field.linkedClass && (!field.fieldValues || Object.keys(field.fieldValues).length === 0)">
                                            <b-link @click="showFvsModal(field, $event.target)" class="text-primary"
                                                    v-b-tooltip.hover.right title="Preload and edit values">
                                                <b-icon icon="arrow-repeat"></b-icon>
                                            </b-link>
                                        </b-input-group-append>
                                        <b-input-group-append is-text
                                                              v-if="field.linkedClass && field.fieldValues && Object.keys(field.fieldValues).length > 0">
                                            <b-link @click="removeAllValues(field)" class="text-danger"
                                                    v-b-tooltip.hover.right title="Remove loaded values">
                                                <b-iconstack>
                                                    <b-icon stacked icon="arrow-repeat"></b-icon>
                                                    <b-icon stacked icon="slash"></b-icon>
                                                </b-iconstack>
                                            </b-link>
                                        </b-input-group-append>
                                        <b-input-group-append is-text
                                                              v-if="field.linkedClass && field.fieldValues && Object.keys(field.fieldValues).length > 0">
                                            <b-link @click="showFvsModal(field, $event.target)" class="text-secondary"
                                                    v-b-tooltip.hover.right title="Show values">
                                                <b-icon icon="list-ol"></b-icon>
                                            </b-link>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <!-- Autocomplete object -->
                                    <b-input-group v-if="$enums['fieldTypesObj'].includes(field.type) &&
                                        !(currentPortal.leadSpace && field.name && field.name.includes('tags.'))">
                                        <b-form-select :id="getFieldId(stepIndex, field.position,'linkedClass')"
                                                       :name="getFieldId(stepIndex, field.position,'linkedClass')"
                                                       v-model="field.linkedClass" :options="currentPortal.leadSpace ? fieldObjectNG : fieldObject" required/>
                                        <b-input-group-append is-text
                                                              v-if="(field.type === 'autocomplete_create' || field.type === 'autocompletes_create') && field.linkedClass">
                                            <b-link @click="showSCModal(field, $event.target)" class="text-primary"
                                                    v-b-tooltip.hover.right title="Setup creation popup">
                                                <b-icon icon="gear-fill"></b-icon>
                                            </b-link>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <!-- Deal : tags-->
                                    <b-input-group v-if="currentPortal.leadSpace && field.name && field.name.includes('tags.')">
                                        <b-form-input :id="getFieldId(stepIndex, field.position,'linkedClass')"
                                                      :name="getFieldId(stepIndex, field.position,'linkedClass')"
                                                      :value="field.linkedClass" @change="v => field.linkedClass = v" disabled/>
                                        <b-input-group-append is-text v-if="field.linkedClass">
                                            <b-link @click="showTagModal(field, $event.target)" class="text-primary"
                                                    v-b-tooltip.hover.right title="Setup tag popup">
                                                <b-icon icon="gear-fill"></b-icon>
                                            </b-link>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-td>
                                <!-- Field required -->
                                <b-td class="text-center align-middle col-ckc">
                                    <b-form-checkbox :id="getFieldId(stepIndex, field.position,'required')"
                                                     :name="getFieldId(stepIndex, field.position,'required')"
                                                     v-model="field.required"/>
                                </b-td>
                                <!-- Field hidden -->
                                <b-td class="text-center align-middle col-ckc">
                                    <b-form-checkbox :id="getFieldId(stepIndex, field.position,'hidden')"
                                                     :name="getFieldId(stepIndex, field.position,'hidden')"
                                                     v-model="field.hidden"/>
                                </b-td>
                                <b-td class="text-center align-middle col-icon">
                                    <b-link @click="removeField(field.position)" class="h4 text-danger"
                                            v-if="fields.length > 1">
                                        <b-icon icon="x-circle"></b-icon>
                                    </b-link>
                                </b-td>
                                <b-td class="text-center align-middle col-icon">
                                    <b-link :id="getFieldId(stepIndex, field.position,'more')"
                                            class="h4 text-secondary">
                                        <b-icon icon="three-dots-vertical"></b-icon>
                                    </b-link>
                                    <b-popover :target="getFieldId(stepIndex, field.position,'more')"
                                               placement="bottomleft" custom-class="popover-dd" triggers="click blur">
                                        <b-list-group>
                                            <b-list-group-item button @click="duplicateField(field)">
                                                <b-icon icon="files" font-scale="1.5" class="mr-2"></b-icon>
                                                Duplicate
                                            </b-list-group-item>
                                            <b-list-group-item button @click="copyToClipboard(field)">
                                                <b-iconstack font-scale="1.5" class="mr-2">
                                                    <b-icon stacked icon="file-earmark" shift-h="-2"
                                                            shift-v="2"></b-icon>
                                                    <b-icon stacked icon="file-earmark-text-fill" shift-h="2"
                                                            shift-v="-2"></b-icon>
                                                </b-iconstack>
                                                Copy to clipboard
                                            </b-list-group-item>
                                            <b-list-group-item button @click="pasteFromClipboard(field)">
                                                <b-icon icon="clipboard" font-scale="1.5" class="mr-2"></b-icon>
                                                Paste from clipboard
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-popover>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td colspan="12" style="padding: 0;">
                                    <b-collapse :id="getFieldId(stepIndex, field.position,'collapse-details')"
                                                @show="setDetailsVisible(field.position, true)" @hidden="setDetailsVisible(field.position, false)">
                                        <b-card bg-variant="light" v-if="getDetailsVisible(field.position) && field.type === 'displayText'">
                                            <b-form-group label="Content"
                                                          :label-for="getFieldId(field.position,'description')">
                                                <ace-editor :id="getFieldId(stepIndex, field.position,'description')"
                                                            :name="getFieldId(stepIndex, field.position,'description')"
                                                            v-model="field.description"
                                                            @init="editorInit" :options="editorOptions" lang="html"
                                                            theme="chrome"
                                                            width="100%"></ace-editor>
                                            </b-form-group>
                                        </b-card>
                                        <b-card bg-variant="light" v-if="getDetailsVisible(field.position) && field.type !== 'displayText'">
                                            <b-form-row>
                                                <b-col md="6">
                                                    <b-form-group label="Default value"
                                                                  :label-for="getFieldId(stepIndex, field.position,'defaultValue')">
                                                        <b-form-input
                                                            :id="getFieldId(stepIndex, field.position,'defaultValue')"
                                                            :name="getFieldId(stepIndex, field.position,'defaultValue')"
                                                            :value="field.defaultValue" @change="v => field.defaultValue = v"/>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col md="6">
                                                    <b-form-group label="Max characters"
                                                                  :label-for="getFieldId(stepIndex, field.position,'maxLength')">
                                                        <b-form-input
                                                            :id="getFieldId(stepIndex, field.position,'maxLength')"
                                                            :name="getFieldId(stepIndex, field.position,'maxLength')"
                                                            v-model="field.maxLength" type="number"/>
                                                    </b-form-group>
                                                </b-col>
                                            </b-form-row>
                                            <b-form-group label="Description"
                                                          :label-for="getFieldId(field.position,'description')">
                                                <ace-editor :id="getFieldId(stepIndex, field.position,'description')"
                                                            :name="getFieldId(stepIndex, field.position,'description')"
                                                            v-model="field.description"
                                                            @init="editorInit" :options="editorOptions" lang="html"
                                                            theme="chrome"
                                                            width="100%"></ace-editor>
                                            </b-form-group>
                                            <b-form-group>
                                                <label :for="getFieldId(stepIndex, field.position,'fieldCondition')">Display
                                                    condition
                                                    <b-link
                                                        :id="getFieldId(stepIndex, field.position,'fieldConditionHelp')">
                                                        <b-icon icon="question-circle" variant="primary"></b-icon>
                                                    </b-link>
                                                    <b-popover
                                                        :target="getFieldId(stepIndex, field.position,'fieldConditionHelp')"
                                                        triggers="focus" placement="top">
                                                        <b>Syntax : </b><br>
                                                        <i>[Field name]<b>=</b>[value]<b>|</b>[other value]</i><br>
                                                        Each <b>AND</b> condition separated by ','<br>
                                                        <b>Example
                                                            : </b><i>listValue1=ValueA,listValue2=ValueB|ValueC</i>
                                                    </b-popover>
                                                </label>
                                                <b-form-input :id="getFieldId(stepIndex, field.position,'condition')"
                                                              :name="getFieldId(stepIndex, field.position,'condition')"
                                                              :value="field.condition" @change="v => field.condition = v"/>
                                            </b-form-group>
                                            <b-form-row>
                                                <b-col md="6">
                                                    <b-form-group label="Popup link label"
                                                                  :label-for="getFieldId(stepIndex, field.position,'linkText')"
                                                                  v-if="field.type === 'checkbox'">
                                                        <b-form-input
                                                            :id="getFieldId(stepIndex, field.position,'linkText')"
                                                            :name="getFieldId(stepIndex, field.position,'linkText')"
                                                            :value="field.linkText" @change="v => field.linkText = v"/>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col md="6">
                                                    <b-form-group label="Popup Title"
                                                                  :label-for="getFieldId(stepIndex, field.position,'modalTitle')"
                                                                  v-if="field.type === 'checkbox' && field.linkText">
                                                        <b-form-input
                                                            :id="getFieldId(stepIndex, field.position,'modalTitle')"
                                                            :name="getFieldId(stepIndex, field.position,'modalTitle')"
                                                            :value="field.modalTitle" @change="v => field.modalTitle = v"/>
                                                    </b-form-group>
                                                </b-col>
                                            </b-form-row>
                                            <b-form-group label="Popup Html content"
                                                          :label-for="getFieldId(stepIndex, field.position,'modalHtmlContent')"
                                                          v-if="field.type === 'checkbox' && field.linkText">
                                                <ace-editor
                                                    :id="getFieldId(stepIndex, field.position,'modalHtmlContent')"
                                                    :name="getFieldId(stepIndex, field.position,'modalHtmlContent')"
                                                    v-model="field.modalHtmlContent" @init="editorInit"
                                                    :options="editorOptions" lang="html" theme="chrome"
                                                    width="100%"></ace-editor>
                                            </b-form-group>
                                        </b-card>
                                    </b-collapse>
                                </b-td>
                            </b-tr>
                        </b-table-simple>
                    </b-td>
                </b-tr>
            </draggable>
        </b-table-simple>

        <!-- Field values modal -->
        <b-modal :id="fvsModal.id" :title="fvsModal.title" size="xl" ok-only @hide="resetFvsModal" centered scrollable>
            <field-values :currentPortal="currentPortal" :field="fvsModal.currentField" :items="Object.values(fvsModal.items)"/>
        </b-modal>

        <!-- Step creation modal -->
        <b-modal :id="scModal.id" :title="scModal.title" ok-only @hide="resetSCModal" size="xl" centered scrollable>
            <b-form-group label="Title" label-for="scTitle" class="required">
                <b-form-input id="scTitle" name="scTitle" v-model="scModal.step.name" required/>
            </b-form-group>
            <PortalFields :step="scModal.step" :step-index="99"
                          :fields="orderByPosition(scModal.step.fields)" :currentPortal="currentPortal"/>
        </b-modal>

        <!-- Field import configuration -->
        <b-modal :id="importFieldModal.id" title="Import field configuration" size="lg" @ok="importField"
                 ok-title="Import" :ok-disabled="importFieldModal.loading" :cancel-disabled="importFieldModal.loading">
            <b-overlay :show="importFieldModal.loading">
                <b-form-textarea id="import-field-content" placeholder="Paste field configuration here" rows="8"
                                 v-model="importFieldModal.fieldContent"></b-form-textarea>
            </b-overlay>
        </b-modal>

        <!-- Field tags modal -->
        <b-modal :id="tagModal.id" :title="tagModal.title" ok-only @hide="resetTagModal" size="xl" centered scrollable>
            <field-tags :currentPortal="currentPortal" :field="tagModal.currentField" :items="tagModal.items"/>
        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";
    import ClientDataService from "@/services/ClientDataService";
    import OppService from "@/services/OppService";
    import StringUtils from "@/services/utils/StringUtils";
    import EditorUtils from "@/services/utils/EditorUtils";
    import draggable from "vuedraggable";
    import PortalUtils from "@/services/utils/PortalUtils";
    import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
    import LeadSpaceDataService from "@/services/LeadSpaceDataService";
    import FieldTags from "@/components/configuration/portal/PortalFieldTags";
    import FieldValues from "@/components/configuration/portal/PortalFieldValues";

    export default {
        name: "PortalFields",
        mixins: [StringUtils, EditorUtils, PortalUtils],
        components: {
            FieldTags,
            FieldValues,
            draggable,
            VueTypeaheadBootstrap
        },
        props: {
            step: Object,
            stepIndex: Number,
            fields: Array,
            currentPortal: Object,
            infoGroups: Array
        },
        data() {
            return {
                // Table fields/columns
                valueFields: [
                    {key: 'value', class: 'required'},
                    {key: 'label', class: 'required'},
                    {key: 'position', class: 'required'},
                    {key: 'edit', class: 'text-center align-middle col-icon'}
                ],
                // Values
                fieldSizes: [
                    {value: 'short', text: 'Short'},
                    {value: 'long', text: 'Long'},
                ],
                fieldObject: [
                    {value: 'Organization', text: 'Organization'},
                    // {value: 'Contact', text: 'Contact'},
                ],
                fieldObjectNG: [
                    {value: 'DirectoryCompany', text: 'DirectoryCompany'},
                ],
                fvsModal: {
                    id: 'field-values-modal-' + this.step.position,
                    title: '',
                    items: [],
                    currentField: {}
                },
                scModal: {
                    id: 'step-creation-modal-' + this.step.position,
                    title: '',
                    step: {}
                },
                tagModal: {
                    id: 'field-tags-modal-' + this.step.position,
                    title: '',
                    items: [],
                    currentField: null,
                },
                importFieldModal: {
                    id: 'modal-import-field-' + this.step.position,
                    loading: false,
                    fieldIndex: null,
                    fieldContent: '',
                },
                lsFields: [],
                lsContactFields: [],
                detailsVisible: []
            }
        },
        mounted() {
            OppService.getLSFields()
                .then(response => {
                    this.lsFields = response.data;
                    this.lsFields.push(...this.infoGroups);
                })
                .catch(error => {
                    console.log(error)
                });
            OppService.getLSContactFields()
                .then(response => {
                    this.lsContactFields = response.data;
                })
                .catch(error => {
                    console.log(error)
                });
            this.initDetailsVisible();
        },
        methods: {
            initDetailsVisible() {
                this.fields.forEach((field) => {
                    this.detailsVisible[field.position] = false;
                });
            },
            setDetailsVisible(position, value) {
                this.detailsVisible.splice(position, 1, value);
            },
            getDetailsVisible(position) {
                return this.detailsVisible[position] ? this.detailsVisible[position] : false;
            },
            changePosition: function () {
                this.fields.forEach((field, index) => {
                    field.position = index;
                });
            },
            orderByPosition(list) {
                return _.orderBy(list, 'position')
            },
            getFieldId(stepIndex, index, attribute) {
                return 'step' + stepIndex + '-field' + index + '-' + attribute;
            },
            getFieldValueId(index, attribute) {
                return 'Value' + index + '-' + attribute;
            },
            addField() {
                let lastPos = (this.step.fields.length > 0) ? _.maxBy(this.step.fields, 'position').position : -1;
                this.step.fields.push({position: lastPos + 1, name: "", required: false, btnStyled: false, fieldValues: {}});
            },
            removeField(position) {
                const index = this.step.fields.findIndex(item => item.position === position);
                this.step.fields.splice(index, 1)
            },
            removeValue(field, index) {
                this.$delete(field.fieldValues, index);
            },
            removeAllValues(field) {
                this.$bvModal.msgBoxConfirm('Are you sure you want to remove all loaded field values ?', {
                    title: 'Please Confirm',
                    okVariant: 'success',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    hideHeaderClose: false,
                })
                    .then(value => {
                        if (value) {
                            field.fieldValues = {};
                            this.$root.$emit('bv::hide::modal', this.fvsModal.id)
                        }
                    })
                    .catch(error => console.log(error));
            },
            retrieveValues(field) {
                this.$bvModal.msgBoxConfirm('Are you sure you want to load field values ?', {
                    title: 'Please Confirm',
                    okVariant: 'success',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    hideHeaderClose: false,
                })
                    .then(value => {
                        if (value) {
                            this.$bvModal.show('loading-modal');
                            if (this.currentPortal.leadSpace) {
                                LeadSpaceDataService.getFieldValues(this.currentPortal.client.id, this.currentPortal.client.name, field.linkedClass)
                                    .then(response => {
                                        field.fieldValues = response.data;
                                        this.$bvModal.hide('loading-modal');
                                    })
                                    .catch(error => {
                                        console.log(error)
                                        this.$parent.$parent.displayErrorMessage('An error occurred while trying to load the fields values.');
                                    });

                            } else {
                                ClientDataService.findValues(this.currentPortal.client.id, field.linkedClass)
                                    .then(response => {
                                        field.fieldValues = response.data;
                                        this.$bvModal.hide('loading-modal');
                                    })
                                    .catch(error => {
                                        console.log(error)
                                        this.$parent.$parent.$parent.displayErrorMessage('An error occurred while trying to load the fields values.');
                                    });
                            }
                        }
                    })
                    .catch(error => console.log(error));
            },
            showFvsModal(field, button) {
                this.fvsModal.title = 'Field values for linked class : ' + field.linkedClass;
                this.fvsModal.currentField = field;

                if (this.currentPortal.leadSpace) {
                    LeadSpaceDataService.getFieldValues(this.currentPortal.client.id, this.currentPortal.client.name, field.linkedClass)
                        .then(response => {
                            this.fvsModal.items = response.data;
                        })
                        .catch(error => {
                            console.log(error)
                            this.$parent.$parent.displayErrorMessage('An error occurred while trying to load the fields values.');
                        });

                } else {
                    ClientDataService.findValues(this.currentPortal.client.id, field.linkedClass)
                        .then(response => {
                            this.fvsModal.items = response.data;
                        })
                        .catch(error => {
                            console.log(error)
                            this.$parent.$parent.$parent.displayErrorMessage('An error occurred while trying to load the fields values.');
                        });
                }

                this.$root.$emit('bv::show::modal', this.fvsModal.id, button)
            },
            resetFvsModal() {
                this.fvsModal.title = '';
                this.fvsModal.currentField = null;
                this.fvsModal.items = [];
            },
            showSCModal(field, button) {
                if (!field.stepCreation) {
                    field.stepCreation = {type: "CREATION", fields: []}
                }
                this.scModal.title = 'Fields content for : ' + field.linkedClass;
                this.scModal.step = field.stepCreation;
                this.$root.$emit('bv::show::modal', this.scModal.id, button)
            },
            resetSCModal() {
                this.scModal.title = '';
                this.scModal.step = {};
            },
            duplicateField(field) {
                let lastPos = (this.fields.length > 0) ? _.maxBy(this.fields, 'position').position : -1;
                let newField = this.cloneDuplicateField(field);
                newField.position = lastPos + 1;
                this.fields.push(newField);
            },
            copyToClipboard(field) {
                let newField = this.cloneDuplicateField(field);
                this.$copyText(JSON.stringify(newField)).then(() => {
                    this.$bvToast.toast(`Field "${field.name}" configuration copied to clipboard.`, {
                        title: 'Field copied to clipboard',
                        variant: 'primary',
                        toaster: 'b-toaster-bottom-left',
                        solid: true,
                        appendToast: false
                    })
                }, function (e) {
                    this.$bvToast.toast(e, {
                        title: 'Could not copy field configuration to clipboard.',
                        variant: 'danger',
                        toaster: 'b-toaster-bottom-left',
                        solid: true,
                        appendToast: false
                    })
                })
            },
            pasteFromClipboard(field) {
                this.importFieldModal.fieldIndex = this.fields.findIndex(item => item.position === field.position);
                this.importFieldModal.fieldContent = '';
                this.importFieldModal.loading = false;
                this.$root.$emit('bv::show::modal', this.importFieldModal.id);
            },
            importField(event) {
                event.preventDefault();
                this.importFieldModal.loading = true;
                let newField = JSON.parse(this.importFieldModal.fieldContent);
                newField.position = this.fields[this.importFieldModal.fieldIndex].position;
                this.fields[this.importFieldModal.fieldIndex] = newField;
                this.$nextTick(() => {
                    this.$bvModal.hide(this.importFieldModal.id)
                    this.importFieldModal.loading = false;
                    this.$bvToast.toast(`Field "${newField.name}" configuration successfully imported from clipboard.`, {
                        title: 'Field imported',
                        variant: 'primary',
                        toaster: 'b-toaster-bottom-left',
                        solid: true,
                        appendToast: false
                    })
                })
            },
            selectField(field, event) {
                field.name = event.name;
                if (!field.label && event.label) {
                    field.label = event.label;
                }
                if (event.linkedClass) {
                    field.linkedClass = event.linkedClass;
                }
                this.$forceUpdate();
            },
            // Tags
            showTagModal(field, button){
                this.tagModal.title = 'Fields content for : ' + field.linkedClass;
                if (!field.fieldValues) {
                    field.fieldValues = {};
                }
                this.tagModal.currentField = field;

                if (this.tagModal.items.length === 0) {
                    LeadSpaceDataService.findAllLeadTags(this.currentPortal.client.id, this.currentPortal.client.name)
                        .then(response => {
                            this.tagModal.items = response.data;
                        })
                        .catch(error => {
                            console.log(error)
                            this.$parent.$parent.displayErrorMessage('An error occurred while trying to load tags.');
                        });
                }
                this.$root.$emit('bv::show::modal', this.tagModal.id, button)
            },
            resetTagModal() {
                this.tagModal.title = '';
            },
        }
    }
</script>

<style lang="scss">
    div[id^=step-creation-modal] .modal-xl {
        max-width: 95%;
    }

    .table-responsive {
        overflow-x: unset;
    }
</style>